export const Cap = [
  {
    store: '0105',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0106',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0110',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0111',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0114',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 192
  },
  {
    store: '0115',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0116',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 384
  },
  {
    store: '0117',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0118',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0119',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: '0121',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0122',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0123',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0126',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0127',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0128',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0129',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0130',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0131',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0132',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0133',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0134',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 404,
    September: 404,
    October: 404,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480
  },
  {
    store: '0136',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0137',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: '0138',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0139',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0140',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0141',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0143',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0144',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0145',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0146',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 422
  },
  {
    store: '0147',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 403
  },
  {
    store: '0148',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0149',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0151',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0152',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0153',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288
  },
  {
    store: '0154',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0155',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0156',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0157',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0159',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0160',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0161',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0163',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0164',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: '0165',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0170',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0172',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0174',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0175',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0178',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0179',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0201',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230
  },
  {
    store: '0202',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0203',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0204',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0205',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0206',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0207',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0208',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0209',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0210',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0213',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0218',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0220',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0221',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0222',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0224',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0226',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0232',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0233',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0234',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0238',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0243',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0244',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0245',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0247',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0248',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0249',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0251',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0253',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0254',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0255',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0256',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0257',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0258',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0260',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: '0261',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0262',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0263',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0264',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0265',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0266',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0268',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0270',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0272',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288
  },
  {
    store: '0273',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0274',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0275',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0276',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0277',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0278',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192
  },
  {
    store: '0279',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0280',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0281',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0283',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0284',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0285',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0287',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307
  },
  {
    store: '0288',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0289',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0347',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0349',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0352',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0356',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0357',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0358',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0359',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0360',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0362',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0363',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0364',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0365',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0366',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0367',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0368',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0370',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0371',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0373',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0374',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0375',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 422
  },
  {
    store: '0376',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0378',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0380',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0381',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0383',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0385',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0386',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0389',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0401',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0402',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0403',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230
  },
  {
    store: '0404',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0405',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 499
  },
  {
    store: '0406',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288
  },
  {
    store: '0408',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0410',
    February: 519,
    March: 519,
    April: 519,
    May: 519,
    June: 519,
    July: 519,
    August: 519,
    September: 519,
    October: 519,
    November: 519,
    'Black Friday': 519,
    December: 519,
    January: 518
  },
  {
    store: '0411',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0413',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0414',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0415',
    February: 384,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 576
  },
  {
    store: '0416',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0417',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0419',
    February: 384,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: '0420',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0421',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0422',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0423',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0424',
    February: 346,
    March: 346,
    April: 346,
    May: 480,
    June: 480,
    July: 480,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480
  },
  {
    store: '0428',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0429',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: '0430',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0431',
    February: 0,
    March: 0,
    April: 135,
    May: 173,
    June: 173,
    July: 173,
    August: 308,
    September: 308,
    October: 308,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 614
  },
  {
    store: '0432',
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: '0441',
    February: 634,
    March: 634,
    April: 634,
    May: 634,
    June: 634,
    July: 634,
    August: 634,
    September: 634,
    October: 634,
    November: 711,
    'Black Friday': 711,
    December: 711,
    January: 710
  },
  {
    store: '0442',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0443',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0445',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0446',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0447',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 557
  },
  {
    store: '0452',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0453',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0455',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0456',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0457',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0458',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0459',
    February: 173,
    March: 173,
    April: 173,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0464',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0467',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 307
  },
  {
    store: '0468',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: '0469',
    February: 404,
    March: 404,
    April: 404,
    May: 442,
    June: 442,
    July: 442,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 480
  },
  {
    store: '0470',
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: '0471',
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0472',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0473',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0474',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 365
  },
  {
    store: '0475',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0476',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0477',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: '0478',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0480',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0481',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307
  },
  {
    store: '0482',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0483',
    February: 384,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 499
  },
  {
    store: '0485',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0486',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0488',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0489',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0501',
    February: 135,
    March: 135,
    April: 135,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0503',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0504',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0505',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0506',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0507',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0508',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0509',
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0513',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0514',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0516',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0518',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0519',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0522',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0523',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0524',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0526',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0527',
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0528',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0529',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0530',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0531',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0534',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307
  },
  {
    store: '0537',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0539',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0540',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0541',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0542',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0550',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0551',
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: '0552',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0553',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0554',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0555',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0556',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0561',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0562',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0563',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0564',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0565',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0566',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0568',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0569',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0571',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192
  },
  {
    store: '0574',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0576',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0577',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0578',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0580',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0581',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0582',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0583',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0584',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0585',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192
  },
  {
    store: '0586',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0587',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0588',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0589',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0597',
    February: 0,
    March: 0,
    April: 0,
    May: 173,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0598',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0601',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0603',
    February: 384,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: '0606',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0607',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0608',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0609',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0610',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0611',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0612',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269
  },
  {
    store: '0614',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0615',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0616',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0618',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422
  },
  {
    store: '0620',
    February: 442,
    March: 442,
    April: 442,
    May: 442,
    June: 442,
    July: 442,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442
  },
  {
    store: '0625',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0627',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0628',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0629',
    February: 596,
    March: 596,
    April: 596,
    May: 596,
    June: 596,
    July: 596,
    August: 596,
    September: 596,
    October: 596,
    November: 596,
    'Black Friday': 596,
    December: 596,
    January: 595
  },
  {
    store: '0630',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0632',
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0633',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0634',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0635',
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: '0636',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 288
  },
  {
    store: '0637',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0638',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0639',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0640',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0641',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0642',
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0643',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250
  },
  {
    store: '0644',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0645',
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0647',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0648',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0649',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0650',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0651',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0652',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307
  },
  {
    store: '0653',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0654',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0657',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0658',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0659',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326
  },
  {
    store: '0660',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0662',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0663',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 288
  },
  {
    store: '0664',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0665',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0667',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0668',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0669',
    February: 423,
    March: 423,
    April: 423,
    May: 423,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422
  },
  {
    store: '0671',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0673',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0674',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: '0679',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0680',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0683',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0684',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0687',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0701',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0702',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211
  },
  {
    store: '0703',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0704',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0707',
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0711',
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0720',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0721',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0722',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211
  },
  {
    store: '0723',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0724',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0725',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0726',
    February: 480,
    March: 480,
    April: 480,
    May: 480,
    June: 480,
    July: 480,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480
  },
  {
    store: '0727',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0728',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0729',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0730',
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0731',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0732',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0733',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 403
  },
  {
    store: '0734',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 307
  },
  {
    store: '0735',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0736',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0737',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0739',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0740',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0742',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0743',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 173
  },
  {
    store: '0744',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0745',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0747',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0748',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0770',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0772',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0773',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0775',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0776',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0778',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269
  },
  {
    store: '0779',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0801',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 288
  },
  {
    store: '0802',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0803',
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0804',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0805',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0806',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0808',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0809',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0810',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0812',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0813',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0816',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0817',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0818',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0863',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0865',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0866',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0875',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0877',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0880',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0881',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0882',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0883',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0884',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211
  },
  {
    store: '0887',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0888',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0901',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0902',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0903',
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: '0904',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0906',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 346
  },
  {
    store: '0907',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0908',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0909',
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0910',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0912',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0914',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0915',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0916',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0917',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0918',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0919',
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: '0920',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0921',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0922',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0925',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0926',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288
  },
  {
    store: '0927',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: '0928',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0929',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0930',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0931',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0932',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: '0933',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0934',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0935',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0939',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 423,
    September: 423,
    October: 423,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 538
  },
  {
    store: '0940',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0941',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0942',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0943',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0944',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0946',
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: '0947',
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 250
  },
  {
    store: '0949',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0950',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0951',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0953',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0954',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0957',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0959',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0961',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0962',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 211
  },
  {
    store: '0963',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0965',
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: '0969',
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: '0970',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0974',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0975',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0976',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0977',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 384
  },
  {
    store: '0980',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: '0981',
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: '0982',
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: '0983',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: '0984',
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: '0989',
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1001,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1002,
    February: 576,
    March: 576,
    April: 576,
    May: 576,
    June: 576,
    July: 576,
    August: 576,
    September: 576,
    October: 576,
    November: 576,
    'Black Friday': 576,
    December: 576,
    January: 576
  },
  {
    store: 1003,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1005,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1006,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 595
  },
  {
    store: 1007,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1009,
    February: 365,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 1010,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1012,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1013,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1014,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1017,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 1018,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1019,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250
  },
  {
    store: 1020,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1022,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1028,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 422
  },
  {
    store: 1030,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1031,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250
  },
  {
    store: 1032,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1034,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1037,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1039,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1040,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1041,
    February: 384,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 384
  },
  {
    store: 1043,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1044,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1048,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 557
  },
  {
    store: 1050,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1052,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1053,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1055,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1059,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1060,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1061,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192
  },
  {
    store: 1062,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1064,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1068,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1069,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1070,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1072,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1073,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 1074,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1076,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1077,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 403
  },
  {
    store: 1080,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 326
  },
  {
    store: 1083,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 1084,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1085,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1086,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1087,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1088,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1089,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1092,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1103,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1104,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1105,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1106,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1108,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1109,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 1110,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1112,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1114,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 1115,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1116,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1117,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1118,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1119,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1120,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288
  },
  {
    store: 1121,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1122,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1124,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1126,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1127,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1129,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1130,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1171,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269
  },
  {
    store: 1202,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1206,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1207,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1208,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1209,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1211,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1212,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 1213,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 1214,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1215,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1216,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1217,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1218,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1220,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 1221,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1222,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1223,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1225,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1227,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1228,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1229,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1230,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1231,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1233,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1234,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1235,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1236,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1238,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1239,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1241,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1242,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1244,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1245,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1246,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1247,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1248,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1249,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1250,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1251,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1252,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1254,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1255,
    February: 192,
    March: 192,
    April: 192,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 1256,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1257,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1258,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1259,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1261,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1262,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1263,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1264,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1265,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1266,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1267,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1268,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1269,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307
  },
  {
    store: 1271,
    February: 212,
    March: 212,
    April: 212,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 1272,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1273,
    February: 212,
    March: 212,
    April: 212,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 1274,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1277,
    February: 500,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499
  },
  {
    store: 1278,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 1281,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 1282,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1284,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1285,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 1286,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1287,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1289,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1301,
    February: 173,
    March: 173,
    April: 173,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1302,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1303,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1304,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269
  },
  {
    store: 1324,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: 1326,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1349,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1379,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1380,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1401,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 230
  },
  {
    store: 1402,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211
  },
  {
    store: 1403,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1404,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1405,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1406,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250
  },
  {
    store: 1407,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1409,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1410,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1411,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1412,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1501,
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: 1502,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1503,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1504,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1505,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1506,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1507,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1508,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1509,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1510,
    February: 596,
    March: 596,
    April: 596,
    May: 596,
    June: 596,
    July: 596,
    August: 596,
    September: 596,
    October: 596,
    November: 596,
    'Black Friday': 596,
    December: 596,
    January: 595
  },
  {
    store: 1511,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1512,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1513,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1514,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1515,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1516,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1517,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 1518,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1519,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1520,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1521,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1522,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1523,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1524,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 1525,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1526,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1528,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1529,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 1531,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1532,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1534,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1535,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1537,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1538,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1540,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 1541,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1542,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1544,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1545,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1546,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1547,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 499
  },
  {
    store: 1548,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 1549,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1550,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1551,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1552,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1601,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1602,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 192
  },
  {
    store: 1603,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192
  },
  {
    store: 1604,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1605,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1608,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1610,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1701,
    February: 557,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557
  },
  {
    store: 1702,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 1703,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1704,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1705,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1706,
    February: 519,
    March: 519,
    April: 519,
    May: 519,
    June: 519,
    July: 519,
    August: 519,
    September: 519,
    October: 519,
    November: 519,
    'Black Friday': 519,
    December: 519,
    January: 518
  },
  {
    store: 1707,
    February: 173,
    March: 173,
    April: 173,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1710,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1747,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1748,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1749,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1750,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1754,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1755,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1763,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1764,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1769,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1770,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1771,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250
  },
  {
    store: 1772,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1773,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1774,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1775,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1777,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1801,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 288
  },
  {
    store: 1802,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1803,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1804,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 1805,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 288
  },
  {
    store: 1806,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 1807,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1808,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1809,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1810,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1811,
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1832,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 1840,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1842,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1843,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1844,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1845,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326
  },
  {
    store: 1846,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1848,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1851,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1853,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1854,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1855,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1856,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1857,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1858,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1859,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1861,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1863,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269
  },
  {
    store: 1866,
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1901,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1902,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1903,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1904,
    February: 346,
    March: 346,
    April: 346,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 1905,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211
  },
  {
    store: 1906,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1907,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 1908,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1909,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1911,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1912,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1913,
    February: 500,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499
  },
  {
    store: 1914,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1915,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250
  },
  {
    store: 1916,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 422
  },
  {
    store: 1917,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1918,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 1919,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1920,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1921,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1922,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1924,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1926,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1927,
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: 1928,
    February: 423,
    March: 423,
    April: 423,
    May: 423,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422
  },
  {
    store: 1932,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1934,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1935,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1936,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1937,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 384
  },
  {
    store: 1938,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1939,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288
  },
  {
    store: 1940,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 1941,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1942,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288
  },
  {
    store: 1943,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1944,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1948,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1950,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1952,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1955,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1956,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1957,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1961,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1962,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 1964,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1967,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1969,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1973,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1974,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1975,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1976,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1977,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1978,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1979,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1980,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 1981,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1982,
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 1983,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 1984,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1986,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 1987,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 1989,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2001,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230
  },
  {
    store: 2002,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2003,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2009,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 2010,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2011,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2012,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2014,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2016,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2017,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2018,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326
  },
  {
    store: 2019,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 307
  },
  {
    store: 2021,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2023,
    February: 154,
    March: 154,
    April: 154,
    May: 173,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2024,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2025,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2026,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2030,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2033,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2034,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 2036,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2037,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 2101,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2103,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2104,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2107,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 2108,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 2109,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2111,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 2113,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 230
  },
  {
    store: 2114,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 2115,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2201,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2202,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269
  },
  {
    store: 2203,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2204,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 2205,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 2207,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 2209,
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 499
  },
  {
    store: 2211,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2213,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2214,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2216,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2217,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 2218,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2219,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2220,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2221,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2301,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2302,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2303,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2304,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 2305,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269
  },
  {
    store: 2306,
    February: 384,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 2307,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2313,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2314,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2315,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 461
  },
  {
    store: 2316,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2317,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2318,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2323,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2324,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2389,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326
  },
  {
    store: 2401,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2403,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2404,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2405,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2406,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2407,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2408,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2409,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2410,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2412,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2414,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2501,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2502,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2503,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2504,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2505,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2506,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2507,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2509,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 2510,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2511,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211
  },
  {
    store: 2550,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 2551,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2552,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2554,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2555,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2557,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2558,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 461
  },
  {
    store: 2559,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269
  },
  {
    store: 2560,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288
  },
  {
    store: 2561,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2562,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2563,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2564,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2565,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2566,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 2567,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2571,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2575,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2576,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2577,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2578,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2579,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2580,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2581,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2582,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 2583,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2584,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2587,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2589,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2602,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2603,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2605,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 614
  },
  {
    store: 2607,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2608,
    February: 212,
    March: 212,
    April: 212,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269
  },
  {
    store: 2609,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2610,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2611,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2612,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2613,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2614,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 2615,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2619,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2623,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2624,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2650,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2651,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2653,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 230
  },
  {
    store: 2659,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2662,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2663,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2665,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2667,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2668,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 2669,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 307
  },
  {
    store: 2670,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2671,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2672,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 2673,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2674,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 2676,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2677,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2678,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2679,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250
  },
  {
    store: 2680,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 173
  },
  {
    store: 2681,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2682,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 2683,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2684,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 2685,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2686,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2688,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2701,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2702,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2703,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 288
  },
  {
    store: 2704,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 2706,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 2707,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2708,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2709,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2710,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2711,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2714,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2715,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2716,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2717,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2718,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2720,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2721,
    February: 269,
    March: 269,
    April: 269,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 2722,
    February: 192,
    March: 192,
    April: 192,
    May: 231,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 2723,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2724,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2725,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2726,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2727,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 2728,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 2729,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2731,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2732,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2733,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2734,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2736,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2737,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2738,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2739,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2740,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 2741,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2742,
    February: 212,
    March: 212,
    April: 212,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2743,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2744,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2747,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2748,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 403
  },
  {
    store: 2751,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2752,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2754,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2755,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2757,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2758,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 2759,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2760,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2761,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2762,
    February: 192,
    March: 192,
    April: 192,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 288
  },
  {
    store: 2763,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2764,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2765,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2766,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2767,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2768,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2769,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2770,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2771,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2772,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2773,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2775,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2776,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2779,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2780,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2781,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2782,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2785,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2789,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2801,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 211
  },
  {
    store: 2802,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2803,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 346,
    September: 346,
    October: 346,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422
  },
  {
    store: 2804,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2805,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2806,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 2807,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2808,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422
  },
  {
    store: 2809,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2810,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 2811,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 2812,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 2813,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2817,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 2818,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2820,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 2821,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2825,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2826,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 442
  },
  {
    store: 2828,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2829,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 2830,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2831,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2832,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2833,
    February: 557,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 691
  },
  {
    store: 2834,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2840,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 2841,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 2842,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 2843,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 2844,
    February: 346,
    March: 346,
    April: 346,
    May: 423,
    June: 423,
    July: 423,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442
  },
  {
    store: 2845,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 2847,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 2901,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 2902,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2903,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2905,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2906,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2907,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2909,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2910,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2912,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2913,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2914,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2915,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 2917,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3001,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 3002,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3003,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3004,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3006,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3007,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3008,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3009,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3010,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3011,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3012,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3013,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3014,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3015,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3016,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3018,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3019,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 3021,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3022,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307
  },
  {
    store: 3024,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3025,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 3026,
    February: 231,
    March: 231,
    April: 231,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 384
  },
  {
    store: 3027,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3029,
    February: 173,
    March: 173,
    April: 173,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3032,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3033,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3034,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3036,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3037,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3038,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3042,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3101,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3102,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3103,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230
  },
  {
    store: 3104,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3105,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3106,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3117,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 3118,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250
  },
  {
    store: 3119,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3201,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 3202,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3203,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 3204,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 500,
    September: 500,
    October: 500,
    November: 576,
    'Black Friday': 576,
    December: 576,
    January: 576
  },
  {
    store: 3206,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 3208,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3209,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 3210,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 3301,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3302,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 346
  },
  {
    store: 3303,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3304,
    February: 173,
    March: 173,
    April: 173,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 3305,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 3306,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 3307,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3308,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3309,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 3310,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3311,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3312,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3313,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3314,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3315,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3316,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3318,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3320,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3322,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3324,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3331,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3401,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 3402,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3403,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3404,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3405,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3406,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3407,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3408,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3409,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3480,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3481,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3482,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3484,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3485,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3486,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3487,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3488,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3489,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3501,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3502,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3503,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3504,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 3505,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3507,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 3508,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250
  },
  {
    store: 3510,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3511,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3514,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3515,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3516,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3517,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3601,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3602,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3603,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3604,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3605,
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 3606,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3607,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 3608,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3609,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3610,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 365
  },
  {
    store: 3615,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 3616,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3620,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3625,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3626,
    February: 442,
    March: 442,
    April: 442,
    May: 442,
    June: 442,
    July: 442,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442
  },
  {
    store: 3627,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3628,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 211
  },
  {
    store: 3629,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3631,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3632,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3633,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3634,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288
  },
  {
    store: 3637,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3638,
    February: 384,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 3639,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3640,
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 3641,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3642,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3644,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 538
  },
  {
    store: 3645,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3646,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3647,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3648,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3650,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3651,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3652,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 596,
    September: 596,
    October: 596,
    November: 711,
    'Black Friday': 711,
    December: 711,
    January: 710
  },
  {
    store: 3655,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3661,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3662,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3663,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3701,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 3703,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3801,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3803,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 3804,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3805,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3806,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3807,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269
  },
  {
    store: 3808,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3809,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3810,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3811,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3812,
    February: 365,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 3813,
    February: 384,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 461
  },
  {
    store: 3814,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3815,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3816,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3817,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3818,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3819,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3820,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3821,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3822,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3823,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3824,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3825,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269
  },
  {
    store: 3827,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3828,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 3830,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3831,
    February: 500,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499
  },
  {
    store: 3832,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 3833,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3835,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3836,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365
  },
  {
    store: 3838,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3841,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3842,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307
  },
  {
    store: 3843,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3844,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3846,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3847,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3848,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 3852,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3854,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3855,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3856,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3857,
    February: 192,
    March: 192,
    April: 192,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 3858,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3859,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 3860,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3861,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326
  },
  {
    store: 3862,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3863,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3864,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 173
  },
  {
    store: 3866,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3867,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3868,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3872,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 3875,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 3877,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3882,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3883,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3885,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3886,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3887,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3888,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3889,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3901,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3902,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3903,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 3904,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 3906,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3907,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3908,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3909,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3911,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3913,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 3914,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 3915,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3917,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 3918,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 3919,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4001,
    February: 1191,
    March: 1191,
    April: 1191,
    May: 1191,
    June: 1191,
    July: 1191,
    August: 1191,
    September: 1191,
    October: 1191,
    November: 1191,
    'Black Friday': 1191,
    December: 1191,
    January: 1382
  },
  {
    store: 4002,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4003,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4004,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4006,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4007,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4008,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4009,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 4010,
    February: 519,
    March: 519,
    April: 519,
    May: 519,
    June: 519,
    July: 519,
    August: 519,
    September: 519,
    October: 519,
    November: 519,
    'Black Friday': 519,
    December: 519,
    January: 518
  },
  {
    store: 4013,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 250
  },
  {
    store: 4014,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 4015,
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 4017,
    February: 538,
    March: 538,
    April: 538,
    May: 538,
    June: 538,
    July: 538,
    August: 538,
    September: 538,
    October: 538,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 538
  },
  {
    store: 4018,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4019,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4020,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4023,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4025,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4026,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4028,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4029,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4030,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4031,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4032,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4034,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4040,
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 4054,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4101,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4102,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4103,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4104,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 4105,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4106,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4108,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4109,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4110,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4112,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4113,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4114,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4115,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 288
  },
  {
    store: 4116,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4117,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4118,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4119,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4120,
    February: 250,
    March: 250,
    April: 250,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 346
  },
  {
    store: 4121,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4122,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4123,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4124,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4125,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4126,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4127,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4128,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4129,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4130,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4131,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 346
  },
  {
    store: 4132,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4134,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4135,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4136,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4137,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4138,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 4139,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4140,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4141,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4142,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4143,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4145,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4148,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230
  },
  {
    store: 4149,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4150,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4152,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4156,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4158,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 4159,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4160,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4162,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4163,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4164,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4166,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4168,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4169,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4171,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230
  },
  {
    store: 4172,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4173,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4176,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4177,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4178,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4180,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4181,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4185,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4186,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4187,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4188,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4213,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4233,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4279,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4280,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4282,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 4283,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4284,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4285,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4286,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4287,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4301,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4401,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 384
  },
  {
    store: 4402,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 4403,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4406,
    February: 500,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 653
  },
  {
    store: 4407,
    February: 500,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 538,
    'Black Friday': 538,
    December: 538,
    January: 538
  },
  {
    store: 4408,
    February: 557,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557
  },
  {
    store: 4409,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4410,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4411,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4412,
    February: 557,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 672,
    'Black Friday': 672,
    December: 672,
    January: 710
  },
  {
    store: 4413,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4414,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4415,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4416,
    February: 634,
    March: 634,
    April: 634,
    May: 634,
    June: 634,
    July: 634,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 634
  },
  {
    store: 4417,
    February: 672,
    March: 672,
    April: 672,
    May: 672,
    June: 672,
    July: 672,
    August: 672,
    September: 672,
    October: 672,
    November: 672,
    'Black Friday': 672,
    December: 672,
    January: 672
  },
  {
    store: 4418,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4419,
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422
  },
  {
    store: 4420,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 480
  },
  {
    store: 4421,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4422,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4461,
    February: 730,
    March: 730,
    April: 730,
    May: 730,
    June: 730,
    July: 730,
    August: 730,
    September: 730,
    October: 730,
    November: 768,
    'Black Friday': 768,
    December: 768,
    January: 730
  },
  {
    store: 4462,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4501,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4502,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4551,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4601,
    February: 423,
    March: 423,
    April: 423,
    May: 423,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422
  },
  {
    store: 4602,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4603,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4604,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 614
  },
  {
    store: 4605,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4607,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4608,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4609,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4611,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4612,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4613,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4614,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4615,
    February: 365,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 4616,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4617,
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: 4618,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4619,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4620,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4621,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4622,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4624,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250
  },
  {
    store: 4626,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4627,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4628,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4631,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4632,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4633,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4634,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211
  },
  {
    store: 4635,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4637,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4638,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4639,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 4640,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4641,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4643,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4645,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4647,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4648,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4650,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4653,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4654,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4655,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4656,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4658,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4659,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4660,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4701,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 250
  },
  {
    store: 4702,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4703,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4704,
    February: 557,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557
  },
  {
    store: 4705,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4706,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4707,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4708,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4709,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4711,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4712,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 403
  },
  {
    store: 4713,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 4714,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4715,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4716,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4718,
    February: 384,
    March: 384,
    April: 384,
    May: 384,
    June: 384,
    July: 384,
    August: 480,
    September: 480,
    October: 480,
    November: 480,
    'Black Friday': 480,
    December: 480,
    January: 518
  },
  {
    store: 4719,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4720,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4722,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4723,
    February: 730,
    March: 730,
    April: 730,
    May: 730,
    June: 730,
    July: 730,
    August: 730,
    September: 730,
    October: 730,
    November: 730,
    'Black Friday': 730,
    December: 730,
    January: 730
  },
  {
    store: 4724,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4725,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4726,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4727,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 346
  },
  {
    store: 4728,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4732,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4734,
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4735,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4737,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4738,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4739,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4740,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4741,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 346
  },
  {
    store: 4742,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4743,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4745,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4746,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 480
  },
  {
    store: 4747,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4748,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4801,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4802,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 4803,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4805,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4878,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4902,
    February: 634,
    March: 634,
    April: 634,
    May: 634,
    June: 634,
    July: 634,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 634
  },
  {
    store: 4903,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4905,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4906,
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: 4907,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 4909,
    February: 519,
    March: 519,
    April: 519,
    May: 576,
    June: 576,
    July: 576,
    August: 653,
    September: 653,
    October: 653,
    November: 653,
    'Black Friday': 653,
    December: 653,
    January: 653
  },
  {
    store: 4910,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4911,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4912,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4915,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4916,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211
  },
  {
    store: 4918,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 4919,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 4920,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 4921,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 4923,
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: 4924,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4925,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 4926,
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 4928,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 4929,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4930,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4931,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 461
  },
  {
    store: 4935,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 4940,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 4941,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 4942,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6001,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6002,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6003,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6004,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6005,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6037,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6105,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6106,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 518
  },
  {
    store: 6107,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6113,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6120,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6140,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6150,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6152,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6153,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 6154,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6155,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6158,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6159,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6160,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6161,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6167,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6168,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6169,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6172,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6173,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6174,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6175,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6176,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6178,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6201,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6202,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6203,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6204,
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 6206,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6207,
    February: 442,
    March: 442,
    April: 442,
    May: 442,
    June: 442,
    July: 442,
    August: 461,
    September: 461,
    October: 461,
    November: 461,
    'Black Friday': 461,
    December: 461,
    January: 461
  },
  {
    store: 6208,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6209,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6210,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6212,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6213,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6214,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6215,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6217,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6218,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6220,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6221,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6223,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6225,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6226,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6228,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6229,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6230,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6233,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6234,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6235,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6236,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 6242,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6301,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6302,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6303,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6304,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6305,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288
  },
  {
    store: 6306,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6310,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6311,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6312,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6313,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6314,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6315,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6316,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6318,
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6319,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6320,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6321,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6322,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6323,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6324,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6325,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6326,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6327,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 326
  },
  {
    store: 6328,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 230
  },
  {
    store: 6329,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6330,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6331,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6332,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6334,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6335,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6336,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6339,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6340,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6341,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230
  },
  {
    store: 6342,
    February: 0,
    March: 0,
    April: 0,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 269
  },
  {
    store: 6343,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6346,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6348,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6349,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6350,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6351,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6353,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6355,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6356,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6357,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6361,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6363,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307
  },
  {
    store: 6364,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6365,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365
  },
  {
    store: 6367,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6368,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6369,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6371,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6372,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6373,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6374,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6375,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6376,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6377,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6378,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6379,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 6380,
    February: 173,
    March: 173,
    April: 173,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6381,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 6401,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6402,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 307
  },
  {
    store: 6403,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 384
  },
  {
    store: 6405,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 6407,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6408,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6409,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326
  },
  {
    store: 6411,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288
  },
  {
    store: 6412,
    February: 365,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 6415,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 653
  },
  {
    store: 6501,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6502,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 326
  },
  {
    store: 6504,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6505,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6506,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 269
  },
  {
    store: 6507,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6509,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6510,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6512,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 230
  },
  {
    store: 6513,
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 6514,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 6515,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 6516,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 6517,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6520,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6521,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6523,
    February: 192,
    March: 192,
    April: 192,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 6525,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6526,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6528,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6529,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6530,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6531,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6532,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6533,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6534,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6537,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6538,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6539,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6540,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6541,
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6542,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6543,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6544,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6545,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6546,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6547,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6548,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6549,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 6550,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6551,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6552,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 615,
    September: 615,
    October: 615,
    November: 730,
    'Black Friday': 730,
    December: 730,
    January: 730
  },
  {
    store: 6553,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6554,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6555,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6556,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250
  },
  {
    store: 6557,
    February: 596,
    March: 596,
    April: 596,
    May: 596,
    June: 596,
    July: 596,
    August: 596,
    September: 596,
    October: 596,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 595
  },
  {
    store: 6558,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6559,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6560,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6561,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6562,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6563,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6564,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 6566,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6567,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6568,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 692,
    'Black Friday': 692,
    December: 692,
    January: 691
  },
  {
    store: 6570,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6571,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6572,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 6574,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6575,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211
  },
  {
    store: 6576,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6577,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6578,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6579,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6580,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6581,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6583,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6584,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6585,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 6586,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365
  },
  {
    store: 6587,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6588,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6589,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6601,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6603,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6604,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 384,
    September: 384,
    October: 384,
    November: 384,
    'Black Friday': 384,
    December: 384,
    January: 384
  },
  {
    store: 6609,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6610,
    February: 557,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557
  },
  {
    store: 6611,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6612,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6613,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6614,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 6615,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 230
  },
  {
    store: 6616,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6617,
    February: 423,
    March: 423,
    April: 423,
    May: 423,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422
  },
  {
    store: 6618,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6619,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307
  },
  {
    store: 6620,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6621,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6623,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6627,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 6628,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6629,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6630,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6632,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6634,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6635,
    February: 672,
    March: 672,
    April: 672,
    May: 672,
    June: 672,
    July: 672,
    August: 672,
    September: 672,
    October: 672,
    November: 672,
    'Black Friday': 672,
    December: 672,
    January: 672
  },
  {
    store: 6636,
    February: 576,
    March: 576,
    April: 576,
    May: 576,
    June: 576,
    July: 576,
    August: 576,
    September: 576,
    October: 576,
    November: 576,
    'Black Friday': 576,
    December: 576,
    January: 576
  },
  {
    store: 6637,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6638,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6639,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6640,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6643,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 230
  },
  {
    store: 6644,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 346
  },
  {
    store: 6645,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 480
  },
  {
    store: 6646,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6647,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6649,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 6650,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6651,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6652,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6654,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6656,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6657,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6660,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6661,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6662,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6663,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6664,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 250
  },
  {
    store: 6665,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6667,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6668,
    February: 308,
    March: 308,
    April: 308,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 6669,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 6670,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6672,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 173
  },
  {
    store: 6673,
    February: 500,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 500,
    September: 500,
    October: 500,
    November: 500,
    'Black Friday': 500,
    December: 500,
    January: 499
  },
  {
    store: 6674,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6675,
    February: 327,
    March: 327,
    April: 327,
    May: 365,
    June: 365,
    July: 365,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6677,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6678,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6679,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 307
  },
  {
    store: 6680,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6681,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6682,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6683,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 346
  },
  {
    store: 6684,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 6687,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 365
  },
  {
    store: 6688,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6689,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6701,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 6804,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6806,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6807,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 326
  },
  {
    store: 6808,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6809,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 442,
    September: 442,
    October: 442,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 442
  },
  {
    store: 6814,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6816,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6817,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6818,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6819,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6820,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6821,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6822,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6827,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6828,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230
  },
  {
    store: 6830,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6831,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6832,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6833,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6834,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 211
  },
  {
    store: 6835,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6837,
    February: 0,
    March: 0,
    April: 0,
    May: 0,
    June: 0,
    July: 0,
    August: 0,
    September: 0,
    October: 0,
    November: 0,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6838,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192
  },
  {
    store: 6839,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6840,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6841,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 211
  },
  {
    store: 6842,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6843,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 6844,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6845,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6846,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6847,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 250,
    September: 250,
    October: 250,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 442
  },
  {
    store: 6848,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6851,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6852,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6853,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6855,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6856,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6857,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6859,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6860,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 403
  },
  {
    store: 6861,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6862,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6863,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6864,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6865,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6866,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 365
  },
  {
    store: 6869,
    February: 346,
    March: 346,
    April: 346,
    May: 346,
    June: 346,
    July: 346,
    August: 346,
    September: 346,
    October: 346,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 346
  },
  {
    store: 6871,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6872,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6874,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6875,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6876,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6877,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6878,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6883,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6884,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6887,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 6888,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6889,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6890,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6891,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 6892,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6893,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 557,
    September: 557,
    October: 557,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 787
  },
  {
    store: 6903,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 326
  },
  {
    store: 6905,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6911,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6917,
    February: 327,
    March: 327,
    April: 327,
    May: 327,
    June: 327,
    July: 327,
    August: 327,
    September: 327,
    October: 327,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 326
  },
  {
    store: 6918,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6919,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269
  },
  {
    store: 6920,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6921,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6923,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269
  },
  {
    store: 6925,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 6928,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6930,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6931,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 250
  },
  {
    store: 6932,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6934,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6935,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6936,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6940,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6941,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6942,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6943,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6945,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6946,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6947,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6948,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6950,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6951,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 6952,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 6954,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 307
  },
  {
    store: 6955,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6956,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6957,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6959,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6960,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6961,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6963,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 6964,
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: 6965,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6966,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6967,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 192
  },
  {
    store: 6968,
    February: 365,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 6971,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6972,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6974,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 269
  },
  {
    store: 6975,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 288
  },
  {
    store: 6976,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6977,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6978,
    February: 596,
    March: 596,
    April: 596,
    May: 596,
    June: 596,
    July: 596,
    August: 634,
    September: 634,
    October: 634,
    November: 634,
    'Black Friday': 634,
    December: 634,
    January: 634
  },
  {
    store: 6979,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 6980,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6981,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6984,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6985,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6986,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 6987,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 6988,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 6989,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8201,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8408,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8412,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8413,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8418,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230
  },
  {
    store: 8419,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8426,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8427,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8429,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8430,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8431,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8433,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8437,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8438,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8439,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8440,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8444,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 8445,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8446,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8447,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8452,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8453,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 8454,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 8456,
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 404,
    'Black Friday': 404,
    December: 404,
    January: 403
  },
  {
    store: 8460,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 8463,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8465,
    February: 404,
    March: 404,
    April: 404,
    May: 404,
    June: 404,
    July: 404,
    August: 404,
    September: 404,
    October: 404,
    November: 442,
    'Black Friday': 442,
    December: 442,
    January: 403
  },
  {
    store: 8466,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 8469,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8472,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8473,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8475,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 8488,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8492,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8493,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8517,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 8518,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8519,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8520,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 8521,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 230
  },
  {
    store: 8523,
    February: 288,
    March: 288,
    April: 288,
    May: 288,
    June: 288,
    July: 288,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 8524,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8525,
    February: 365,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 442
  },
  {
    store: 8526,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8527,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8528,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 231,
    September: 231,
    October: 231,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 230
  },
  {
    store: 8529,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8531,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8537,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8539,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8540,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8545,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8548,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8550,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8551,
    February: 500,
    March: 500,
    April: 500,
    May: 500,
    June: 500,
    July: 500,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557
  },
  {
    store: 8552,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8557,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 327,
    'Black Friday': 327,
    December: 327,
    January: 442
  },
  {
    store: 8560,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8561,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 288,
    September: 288,
    October: 288,
    November: 288,
    'Black Friday': 288,
    December: 288,
    January: 288
  },
  {
    store: 8562,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 8563,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 8566,
    February: 423,
    March: 423,
    April: 423,
    May: 423,
    June: 423,
    July: 423,
    August: 423,
    September: 423,
    October: 423,
    November: 423,
    'Black Friday': 423,
    December: 423,
    January: 422
  },
  {
    store: 8571,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 269
  },
  {
    store: 8572,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8577,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8580,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8582,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 8583,
    February: 557,
    March: 557,
    April: 557,
    May: 557,
    June: 557,
    July: 557,
    August: 557,
    September: 557,
    October: 557,
    November: 557,
    'Black Friday': 557,
    December: 557,
    January: 557
  },
  {
    store: 8584,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8597,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8598,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8622,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 173
  },
  {
    store: 8913,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8916,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8918,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8919,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8922,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 8923,
    February: 365,
    March: 365,
    April: 365,
    May: 365,
    June: 365,
    July: 365,
    August: 365,
    September: 365,
    October: 365,
    November: 365,
    'Black Friday': 365,
    December: 365,
    January: 365
  },
  {
    store: 8924,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8926,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8929,
    February: 269,
    March: 269,
    April: 269,
    May: 269,
    June: 269,
    July: 269,
    August: 269,
    September: 269,
    October: 269,
    November: 269,
    'Black Friday': 269,
    December: 269,
    January: 269
  },
  {
    store: 8931,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8938,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8939,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8940,
    February: 231,
    March: 231,
    April: 231,
    May: 231,
    June: 231,
    July: 231,
    August: 231,
    September: 231,
    October: 231,
    November: 346,
    'Black Friday': 346,
    December: 346,
    January: 384
  },
  {
    store: 8941,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 326
  },
  {
    store: 8944,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8949,
    February: 192,
    March: 192,
    April: 192,
    May: 308,
    June: 308,
    July: 308,
    August: 308,
    September: 308,
    October: 308,
    November: 308,
    'Black Friday': 308,
    December: 308,
    January: 307
  },
  {
    store: 8951,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8954,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8955,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8958,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8964,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8966,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8975,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8976,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8979,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8981,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
  {
    store: 8984,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8987,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 231,
    'Black Friday': 231,
    December: 231,
    January: 346
  },
  {
    store: 8988,
    February: 192,
    March: 192,
    April: 192,
    May: 192,
    June: 192,
    July: 192,
    August: 192,
    September: 192,
    October: 192,
    November: 192,
    'Black Friday': 192,
    December: 192,
    January: 192
  },
  {
    store: 8994,
    February: 250,
    March: 250,
    April: 250,
    May: 250,
    June: 250,
    July: 250,
    August: 250,
    September: 250,
    October: 250,
    November: 250,
    'Black Friday': 250,
    December: 250,
    January: 250
  },
  {
    store: 8995,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8996,
    February: 173,
    March: 173,
    April: 173,
    May: 173,
    June: 173,
    July: 173,
    August: 173,
    September: 173,
    October: 173,
    November: 173,
    'Black Friday': 173,
    December: 173,
    January: 173
  },
  {
    store: 8998,
    February: 212,
    March: 212,
    April: 212,
    May: 212,
    June: 212,
    July: 212,
    August: 212,
    September: 212,
    October: 212,
    November: 212,
    'Black Friday': 212,
    December: 212,
    January: 211
  },
];